import React from 'react';
import { Link } from 'react-router-dom';

/** Arrow at the far left of a breadcrumb; goes to the crumb just before the current page.
 *  Drawn as SVG (not a "←" glyph) so it sits exactly in the middle of its tap area. */
const BreadcrumbBack: React.FC<{ to: string }> = ({ to }) => (
  <Link to={to} className="breadcrumb-back" aria-label="Back" title="Back">
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d="M20 12H4M11 5l-7 7 7 7" />
    </svg>
  </Link>
);

export default BreadcrumbBack;
